/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method,payload) {
  if (metaData != "ticket_label") {
    return api
      .post(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else if (method === "post") {
    return api
      .post(`/get_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export async function loadTicketQueryDetails(searchvalue) {
  if (searchvalue) {
    return await api

      .post(`/get_all_query`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_query`, { status: "active" })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export function addQueryChatDetails(queryChat) {
  return api
    .post(`/add_query_chat`, queryChat)
    .catch((error) => Promise.reject(error))
}
//update Ticket Query

export function updateTicketQueryDetails(updateTicketClose) {
  return api
    .post(`/update_query_status_history`, updateTicketClose)
    .catch((error) => Promise.reject(error))
}
//delete Ticket Query

export function deleteTicketQueryDetails(deleteTicket) {
  return api
    .post(`/delete_query_by_id`, deleteTicket)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadTicketQueryDetails,
  addQueryChatDetails,
  updateTicketQueryDetails,
  deleteTicketQueryDetails,
}

export default remotes
